import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import Product from "emun.shopping/product.model";
import AutoQuery from "servicestack/auto-query/auto-query";
import orderImportItems from "emun.order/import-items/order-import-items";
import orderParseItems from "emun.order/parse-items/order-parse-items";
import cartNewItem from "emun.cart/new-item/cart-new-item";
import actionList from "webmodals/action-list";
import cartConfig from "emun.cart/cart.config";
import cartItemInputConfig from "emun.cart/cart-item-input.config";
import cartItemShipDatePrompt from "emun.cart/cart-item-ship-date";
import * as SDCCore from "scandit-web-datacapture-core";
import * as SDCBarcode from "scandit-web-datacapture-barcode";

const productSorter = (scan) => (a, b) => {
  const aI = a.id.indexOf(scan);
  const bI = b.id.indexOf(scan);
  if (aI === -1 && bI >= 0) return 1;
  if (bI === -1 && aI >= 0) return -1;
  if (aI >= 0 && bI >= 0 && aI > bI) return 1;
  if (aI >= 0 && bI >= 0 && bI > aI) return -1;
  if (bI === aI && aI >= 0) {
    const skuComp = skuLengthSorter(a, b);
    if (skuComp !== 0) return skuComp;
    return availableQtySorter(a, b);
  }
  return availableQtySorter(a, b);
};
const skuLengthSorter = (a, b) => {
  if (a.id.length > b.id.length) return 1;
  if (b.id.length > a.id.length) return -1;
  return 0;
};
const availableQtySorter = (a, b) => {
  if (a.availableQty > b.availableQty) return -1;
  if (b.availableQty > a.availableQty) return 1;
  return 0;
};

export default class CartItemInputController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);

    $ctrl.enableScanScan = false;
    $ctrl.labels = {
      id: "ID",
      shortDescription: "Desc",
      price: "Price",
      extPrice: "Ext. Price",
      cubicVolume: false,
      caseQty: "Case Qty",
      availableQty: $ctrl.$labels.availableQty || "Avail",
      addWithAdditionalInfo: "Add with additional info",
      add: "Add",
      searchResults: "Search Results",
      shipOn: $ctrl.$labels.shipOn,
      weight: $ctrl.$labels.weight,
      volume: $ctrl.$labels.volume
    };
    $ctrl.scanMode = false;
  }

  $onInit() {
    const $ctrl = this;
    if (
      $ctrl.$stateParams.cartId &&
      $ctrl.$stateParams.cartId !== $ctrl.$cart.cartId
    )
      $ctrl.$cart.load($ctrl.$stateParams.cartId);
    if (
      $ctrl.$stateParams.orderId &&
      $ctrl.$stateParams.orderId !== $ctrl.$cart.cartId
    )
    $ctrl.$cart.load($ctrl.$stateParams.orderId);
    $ctrl.prodQuery = new AutoQuery($ctrl.getQueryOptions());
    $ctrl.vendorScan = cartConfig.vendorScan;

    $ctrl.isColAdvancedSearch = true;
    $ctrl.config = cartConfig;
    $ctrl.autoAdd = false;
    $ctrl.prodQuery.criteria.upcOnly = false;
    //    if ($ctrl.config.autoAdd || $ctrl.$session.isShowroom())
    if ($ctrl.config.autoAdd) $ctrl.autoAdd = true;
    if ($ctrl.config.autoAdd) $ctrl.prodQuery.criteria.upcOnly = true;
    if ($ctrl.config.exactMatchShowroomOnly && !$ctrl.$session.isShowroom()) {
      $ctrl.prodQuery.criteria.upcOnly = false;
    }
    resolve("$timeout")(() => {
      $ctrl.clear();
      if ($ctrl.isMobile()) {
        document
          .getElementById("cart-item-input-search-or-scan-mobile")
          .focus();
      } else {
        document.getElementById("cart-item-input-search-or-scan").focus();
      }
    }, 188);
    $ctrl.modelOptions = {
      debounce: $ctrl.prodQuery.criteria.upcOnly ? 175 : $ctrl.config.scanDebounce
    };
    //$ctrl.loadSound();
  }
  // loadSound() {
  // 	let $ctrl = this;
  // 	if (!$ctrl.errorSound) {
  // 		$ctrl.errorSound = $ctrl.config.errorSound
  // 			? new Audio($ctrl.config.errorSound)
  // 			: new Audio("/sounds/alert.wav");
  // 		$ctrl.errorSound.load();
  // 	}
  // 	if (!$ctrl.successSound) {
  // 		$ctrl.successSound = $ctrl.config.successSound
  // 			? new Audio($ctrl.config.successSound)
  // 			: new Audio("/sounds/success.wav");
  // 		$ctrl.successSound.load();
  // 	}
  // }
  toggleExactMatch() {
    const $ctrl = this;
    if ($ctrl.prodQuery.criteria.upcOnly) {
      $ctrl.modelOptions.debounce = 175;
    } else {
      $ctrl.modelOptions.debounce = $ctrl.config.scanDebounce;
    }

  }

  isMobile() {
    const $ctrl = this;
    return $ctrl.$pageConfig.width < 544;
  }

  getQueryOptions() {
    const $ctrl = this;
    return {
      url: "QueryProducts.json?V=Scan&",
      autoLoad: false,
      append: true,
      orderBy: cartItemInputConfig.orderBy || "Id",
      criteria: {
        //  IsRestricted: 0
      },
      pageSize: cartItemInputConfig.pageSize || 12,
      beforeLoading({ request }) {
        request.cartId = $ctrl.$cart.cartId;
      },
      scrub: (res) =>
        (res.data.results = Product.map(
          cartItemInputConfig.disableProductSorter
            ? res.data.results
            : res.data.results.sort(
                productSorter($ctrl.prodQuery.criteria.scan)
              )
        )),
      onLoaded: (args) => $ctrl.productsLoaded(args),
    };
  }

  addMultiItem() {
    const $ctrl = this;
    $ctrl.$cart.addMultiItem($ctrl.prodQuery.criteria).then(function () {
      $ctrl.prodQuery.criteria.scan = "";
      $ctrl.products = [];
    });
  }

  addMultiOrders() {
    const $ctrl = this;
    return $ctrl.$cart.addToMultipleOrders($ctrl.product, false);
  }

  getProduct(skuOrUpc) {
    const $ctrl = this;
    //console.info("getProduct", skuOrUpc);
    $ctrl.invalid = false;
    $ctrl.shipOn = undefined;
    if (skuOrUpc && skuOrUpc != "") {
      $ctrl.prodQuery.bus.cancelAll();
      $ctrl.prodQuery.bus
        .read("QueryProducts.json?cart-item-input=getProductyBySkuOrUpc", {
          cartId: $ctrl.$cart.cartId,
          skuOrUpc,
        })
        .then((res) => {
          if (res.data.results.length > 0) {
            $ctrl.setProduct(new Product(res.data.results[0]));
          } else {
            //console.info("$ctrl.$cart", $ctrl.$cart);
            //console.info("$ctrl.prodQuery.criteria.scan.toUpperCase()", $ctrl.prodQuery.criteria.scan.toUpperCase());
            //console.info("invalid", $ctrl.$cart.vendor, $ctrl.$cart.vendor.allowManualItemEntry, cartConfig.allowManualItemEntry);
            $ctrl.invalid = true;
            if (
              $ctrl.$session.isAgency() &&
              $ctrl.$cart.vendor &&
              ($ctrl.$cart.vendor.allowManualItemEntry ||
                cartConfig.allowManualItemEntry(
                  $ctrl.$cart.type || ""
                ) ||
                ($ctrl.$cart.sourceId.toUpperCase() == "DIRECT" &&
                  $ctrl.prodQuery.criteria.scan.toUpperCase() == "SUMMARY"))
            ) {
              if (cartConfig.playErrorSound) {
                $ctrl.$cart.playErrorSound();
                //$ctrl.errorSound.play();
              }
              const invalidItemActions = {
                "Add New Item": {
                  icon: "cart-plus",
                  body: `Enter ${$ctrl.prodQuery.criteria.scan} as a new item`,
                  handler: () =>
                    $ctrl.openNewItem($ctrl.prodQuery.criteria.scan),
                },
                Cancel: {
                  icon: "close",
                  body: "Cancel",
                  handler: function () {
                    $ctrl.clear();
                    return;
                  },
                },
              };
              return actionList({
                title: `${$ctrl.prodQuery.criteria.scan} is not a valid item`,
                subTitle: `How would you like to proceed?`,
                actions: invalidItemActions,
                size: "md",
              }).then((a) => a.handler());
            }
          }
        });
    }
  }

  cartItemShipDate(product) {
    const $ctrl = this;
    return cartItemShipDatePrompt({
      cartItem: product.cartItem,
      product: product,
    }).then((cartItem) => {
      $ctrl.shipOn = cartItem.shipOn; //.format("DD/MM/YYYY");
      //			product.shipOn = cartItem.shipOn.format("MM/DD/YYYY");
    });
  }

  setProduct(p) {
    const $ctrl = this;
    //console.info("setProduct", p);
    var isConfigurable = false;
    $ctrl.products = [];
    $ctrl.$selectedIndex = null;
    $ctrl.invalid = false;
    $ctrl.product = p;
    $ctrl.quantity = $ctrl.product.minimumOrderQty || 1;
    $ctrl.product.qtyIncrement = $ctrl.product.purchaseIncrement || 1;
    if (
      $ctrl.config.useCaseQtyIncrement &&
      $ctrl.product.purchaseIncrement &&
      $ctrl.product.caseQty &&
      $ctrl.quantity >= $ctrl.product.caseQty
    )
      $ctrl.product.qtyIncrement = $ctrl.product.caseQty;
    $ctrl.product.shipDate = $ctrl.$cart.shipOn;
    //$ctrl.product.shipOn = $ctrl.$cart.shipOn;
    $ctrl.prodQuery.criteria.scan = "";
    if (
      $ctrl.config.allowScanInactiveKits &&
      !p.isSellable &&
      p.itemType == "Kit" &&
      p.meta.Components
    ) {
      this.components = JSON.parse(p.meta.Components);
      this.components = this.components.filter((c) => c.Status == "Active");
      if (this.components.length > 0) {
        $ctrl.$cart.multiEdit(
          JSON.parse(p.meta.Components).map((i) => i.ProductId), false
        );
        return;
      }
    }
    $ctrl.$cart.bus
      .validate(
        "AddCartItem.json?cart-item-input=validate",
        p.createCartItem(null, null, $ctrl.quantity)
      )
      .then(
        () => {
          if ($ctrl.product.isConfigurable()) {
            $ctrl.editItem();
            isConfigurable = true;
          }
          //console.info("p", p);
          $ctrl.$broadcast("product-found", p);
          if ($ctrl.autoAdd && !isConfigurable) $ctrl.addProduct();
          else {
            if ($ctrl.isMobile() && document.getElementById("cart-item-input-search-or-scan-mobile")) {
              document
                .getElementById("cart-item-input-search-or-scan-mobile")
                .blur();
            } else {
              document.getElementById("cart-item-input-search-or-scan").blur();
            }
          }
        },
        () => $ctrl.clear()
      )
      .catch(() => $ctrl.clear());
  }

  loadProducts(watchSelectedIndex) {
    const $ctrl = this;
    $ctrl.invalid = false;
    //if (watchSelectedIndex && $ctrl.$selectedIndex >= 0)
    //    return console.warn('lp.cancel', $ctrl.$selectedIndex);
    if (!$ctrl.config.allowSuggestionsOnScan && $ctrl.autoAdd && $ctrl.$session.isShowroom()) return;
    if (
      ($ctrl.prodQuery.criteria.scan || "").length >= 2 ||
      $ctrl.productLineScan
    ) {
      $ctrl.$selectedIndex = null;
      $ctrl.product = null;
      //console.info("vendorScan", $ctrl.vendorScan, $ctrl.$cart.vendorId, !$ctrl.config.hideVendorScanOption);
      if (
        $ctrl.vendorScan &&
        !$ctrl.config.hideVendorScanOption &&
        $ctrl.$cart.vendorId > 0
      ) {
        $ctrl.prodQuery.criteria.vendorId = $ctrl.$cart.vendorId;
      } else {
        $ctrl.prodQuery.criteria.vendorId = undefined;
      }
      if ($ctrl.productLineScan) {
        $ctrl.prodQuery.criteria.productLineId = $ctrl.productLineScan;
      }
      $ctrl.prodQuery.load(true);
    } else {
      $ctrl.products = [];
    }
  }

  productsLoaded(args) {
    const $ctrl = this;
    $ctrl.products = $ctrl.prodQuery.results; //args.results;
    $ctrl.productTotal = args.total;
    $ctrl.invalid = false;
    $ctrl.product = null;
    $ctrl.$lastScan = $ctrl.prodQuery.criteria.scan;
    if (
      args.results.length === 1 &&
      (args.first.id.toUpperCase() ===
        $ctrl.prodQuery.criteria.scan.toUpperCase() ||
        (args.first.upcCode && (args.first.upcCode.toUpperCase() ===
          $ctrl.prodQuery.criteria.scan.toUpperCase())) ||
        args.first.manufacturerNumber.toUpperCase() ===
          $ctrl.prodQuery.criteria.scan.toUpperCase())
    ) {
      $ctrl.setProduct(args.first);
    } else if (cartConfig.setProductIfSingleResult && args.results.length === 1) {
      //console.info("setProductIfSingleResult", args.first);
      $ctrl.setProduct(args.first);

    } else if (args.results.length === 0) {
      //console.info("no results", cartConfig.playErrorSound,$ctrl.$cart.vendor,$ctrl.$cart.vendor.allowManualItemEntry);
      $ctrl.invalid = true;
      if (cartConfig.playErrorSound) {
        //$ctrl.errorSound.play();
        $ctrl.$cart.playErrorSound();
        if (
          $ctrl.$session.isAgency() &&
          $ctrl.$cart.vendor &&
          ($ctrl.$cart.vendor.allowManualItemEntry ||
            ($ctrl.$cart.sourceId.toUpperCase() == "DIRECT" &&
              $ctrl.prodQuery.criteria.scan.toUpperCase() == "SUMMARY"))
        ) {
          //$ctrl.prodQuery.criteria.scan = "";
          
        } else if (!cartConfig.retainSearchWithNoScanResults) {
          //only clear if they can't add it manually
          $ctrl.prodQuery.criteria.scan = "";
        }
      }
    } else {
      $ctrl.$selectedIndex = 0;
    }
  }

  addProductFromNumpad() {
    const $ctrl = this;
    resolve("$timeout")(() => {
      $ctrl.addProduct();
    }, 388);
  }

  addProduct() {
    const $ctrl = this;
    $ctrl.keystrokes = [];
    resolve("$timeout")(() => {
      if ($ctrl.isMobile()) {
        document
          .getElementById("cart-item-input-search-or-scan-mobile")
          .focus();
      } else {
        document.getElementById("cart-item-input-search-or-scan").focus();
      }
      $ctrl.$cart.$itemSearch = "";
    }, 1000);

    //		resolve("$timeout")(() => {

    //console.info("BL*** addProduct quantity = " + $ctrl.quantity);

    //if (!$ctrl.product) return;
    if (!$ctrl.product &&
      $ctrl.$session.isAgency() &&
      $ctrl.$cart.vendor &&
      ($ctrl.$cart.vendor.allowManualItemEntry ||
        ($ctrl.$cart.sourceId.toUpperCase() == "DIRECT" &&
          $ctrl.prodQuery.criteria.scan.toUpperCase() == "SUMMARY"))
    ) {
      //$ctrl.prodQuery.criteria.scan = "";
      //console.info("can add manually");
      const invalidItemActions = {
        "Add New Item": {
          icon: "cart-plus",
          body: `Enter ${$ctrl.prodQuery.criteria.scan} as a new item`,
          handler: () =>
            $ctrl.openNewItem($ctrl.prodQuery.criteria.scan),
        },
        Cancel: {
          icon: "close",
          body: "Cancel",
          handler: function () {
            $ctrl.clear();
            return;
          },
        },
      };
      return actionList({
        title: `${$ctrl.prodQuery.criteria.scan} is not a valid item`,
        subTitle: `How would you like to proceed?`,
        actions: invalidItemActions,
        size: "md",
      }).then((a) => a.handler());
    } else if (!cartConfig.retainSearchWithNoScanResults) {
      return;
    }
    if ($ctrl.quantity < 1) return;
    if (
      $ctrl.product.qtyIncrement > 0 &&
      $ctrl.$cart.type.toUpperCase() !== "SAMPLE" &&
      $ctrl.$cart.type.toUpperCase() !== "REPLACEMENT" &&
      $ctrl.$cart.type.toUpperCase() !== "DROP SHIP"
    ) {
      if ($ctrl.quantity % $ctrl.product.qtyIncrement) {
        // alert("Qty must be in increments of " + $ctrl.product.qtyIncrement);
        $ctrl.$cart.bus.validationErrors = {
          Quantity: [
            {
              errorCode: "-1",
              fieldName: "Quantity",
              message:
                "Quantity must be in increments of " +
                $ctrl.product.qtyIncrement,
            },
          ],
        };
        $ctrl.quantity = $ctrl.product.qtyIncrement;
        $ctrl.$broadcast("product-found", $ctrl.product);
        return;
      }
    }
    const action = /*$ctrl.product.isConfigurable() ? "editItem" :*/ "addItem";
    console.debug("$ctrl.shipOn", $ctrl.shipOn, [action]);
    return $ctrl.$cart[action](
      $ctrl.product.createCartItem(
        null,
        null,
        $ctrl.quantity,
        $ctrl.product.asShownValues,
        null,
        $ctrl.shipOn || null
      ),
      $ctrl.product
    ).then((res) => {
      $ctrl.clear();
      $ctrl.$emit("cart-item-added", res);
      if (cartConfig.playSuccessSound) {
        //$ctrl.successSound.play();
        $ctrl.$cart.playSuccessSound();
      }
      //if ($ctrl.config.autoAdd) $ctrl.autoAdd = true;
      //if ($ctrl.config.autoAdd) $ctrl.prodQuery.criteria.upcOnly = true;
      //if ($ctrl.config.exactMatchShowroomOnly && !$ctrl.$session.isShowroom()) {
      //  $ctrl.prodQuery.criteria.upcOnly = false;
      //}
  
    });
    //		}, 488);
  }

  reset() {
    const $ctrl = this;
    $ctrl.clear();
    if ($ctrl.isMobile()) {
      document.getElementById("cart-item-input-search-or-scan-mobile").focus();
    } else {
      document.getElementById("cart-item-input-search-or-scan").focus();
    }
  }

  editItem() {
    const $ctrl = this;
    if ($ctrl.product) {
      const action = `${
        $ctrl.product.isPersonalizeable() ? "add" : "edit"
      }Item`;
      console.debug("editItem", action, { action, ...$ctrl.product });
      $ctrl.$cart[action](
        $ctrl.product.createCartItem(
          null,
          null,
          $ctrl.quantity,
          $ctrl.product.asShownValues,
          null,
          $ctrl.shipOn || null
        ),
        $ctrl.product
      ).then(
        (res) => {
          $ctrl.clear();
          $ctrl.$emit("cart-item-added", res);
        },
        (res) => {
          $ctrl.clear();
          $ctrl.$emit("cart-item-added", res);
        }
      );
    }
  }

  changeQty(value, direction) {
    const $ctrl = this;
    if (!$ctrl.product) return;
    if ($ctrl.quantity < 1) return;
    if (
      $ctrl.config.useCaseQtyIncrement &&
      $ctrl.product.purchaseIncrement &&
      $ctrl.product.caseQty &&
      value >= $ctrl.product.caseQty &&
      value > $ctrl.quantity
    )
      $ctrl.product.qtyIncrement = $ctrl.product.caseQty;
    else if (
      $ctrl.config.useCaseQtyIncrement &&
      $ctrl.product.purchaseIncrement &&
      $ctrl.product.caseQty &&
      value <= $ctrl.product.caseQty &&
      value < $ctrl.quantity
    )
      $ctrl.product.qtyIncrement = $ctrl.product.purchaseIncrement;
    $ctrl.quantity = value;

    Object.keys($ctrl.product.pricing).forEach((key) => {
      if (value >= key) {
        $ctrl.product.price = $ctrl.product.pricing[key];
      }
    });
  }

  clear() {
    const $ctrl = this;
    $ctrl.quantity = null;
    $ctrl.product = null;
    $ctrl.$selectedIndex = null;
    $ctrl.prodQuery.criteria.scan = "";
    $ctrl.products = [];
    $ctrl.invalid = false;
  }

  increment(delta) {
    const $ctrl = this;
    $ctrl.$selectedIndex =
      ($ctrl.products.length + $ctrl.$selectedIndex + delta) %
      $ctrl.products.length;
  }

  onEnter() {
    const $ctrl = this;
    //console.info("On Enter", $ctrl.prodQuery.criteria.scan);
    if ($ctrl.$selectedIndex >= 0) {
      const p = $ctrl.products[$ctrl.$selectedIndex];
      $ctrl.setProduct(p);
    } else if ($ctrl.product) {
      $ctrl.addProduct("enter.$selectedIndex", $ctrl.$selectedIndex);
    } else if (
      $ctrl.prodQuery.criteria.scan &&
      $ctrl.prodQuery.criteria.scan.length >= 2
    ) {
      $ctrl.getProduct($ctrl.prodQuery.criteria.scan);
    }
  }

  keyPress(e, src) {
    const $ctrl = this;
    //console.debug("kp", e);
    $ctrl.$cart.initAudio();
    if (
      $ctrl.product ||
      !$ctrl.products ||
      !$ctrl.products.length ||
      !($ctrl.$selectedIndex >= 0)
    )
      return; // console.log("cancel.kp", { e, src, $ctrl });

    if (e.keyCode === 38) return $ctrl.increment(-1);
    if (e.keyCode === 40) return $ctrl.increment(1);
    if (e.keyCode === 9) return $ctrl.onEnter();
    if (e.keyCode === 13) return $ctrl.onEnter();
    if (e.keyCode === 27) return $ctrl.clear();
  }

  openImport() {
    return orderImportItems({
      size: "xl",
    }).then((result) => {
      console.debug("result", result);
      window.location.reload();
    });
  }

  openParser() {
    return orderParseItems({
      size: "lg",
    }).then((result) => {
      console.debug("result", result);
      window.location.reload();
    });
  }

  openNewItem(productId) {
    let $ctrl = this;
    return cartNewItem({
      product: {
        id: productId,
        unlisted: true,
        vendorId: $ctrl.$cart.vendorId,
      },
    }).then((p) => {
      $ctrl.product = p;
      $ctrl.quantity = p.quantity;
      $ctrl.prodQuery.criteria.upcOnly = false;
      $ctrl.autoAdd = false;
    });
  }

	enableScanner() {
		const $ctrl = this;
    if (!$ctrl.scanMode) {
      $ctrl.scanMode = true;
      $ctrl.initScanner();  
    } else {
      $ctrl.scanMode = false;
    }
	}
	
	async initScanner() {
		const $ctrl = this;
		  $ctrl.scanditView = new SDCCore.DataCaptureView();
	
		  $ctrl.scanditView.connectToElement(document.getElementById("scandit-reader"));
		  $ctrl.scanditView.showProgressBar();
		  $ctrl.scanditView.setProgressBarMessage("Loading ...");
		  $ctrl.scanditView.hideProgressBar();
	
		  await SDCCore.configure({
			licenseKey: $ctrl.$session.meta.ScanditApiKey, //$ctrl.config.scanditLicense,
			libraryLocation: new URL("assets/scandit-web-datacapture-barcode/build/engine/", document.baseURI).toString(),
			moduleLoaders: [SDCBarcode.barcodeCaptureLoader()]
		  });    
		  $ctrl.scanditContext = await SDCCore.DataCaptureContext.create();
		  await $ctrl.scanditView.setContext($ctrl.scanditContext);
		  $ctrl.scanditSettings = new SDCBarcode.BarcodeCaptureSettings();
		  $ctrl.scanditSettings.enableSymbologies([
			  SDCBarcode.Symbology.Code39,
			  SDCBarcode.Symbology.QR,
			  SDCBarcode.Symbology.DataMatrix,
			  SDCBarcode.Symbology.EAN8,
			  SDCBarcode.Symbology.UPCE,
			  SDCBarcode.Symbology.EAN13UPCA
			]);
		  $ctrl.scanditSettings.codeDuplicateFilter = 1000;
		  $ctrl.scanditBarcodeCapture = await SDCBarcode.BarcodeCapture.forContext($ctrl.scanditContext, $ctrl.scanditSettings);
		  $ctrl.scanditListener = {
			didScan: (barcodeCapture, session) => {
			  const recognizedBarcodes = session.newlyRecognizedBarcodes;
			  console.debug("BL*** barcodes", session.newlyRecognizedBarcodes);
			  session.newlyRecognizedBarcodes.map(barcode => {
				$ctrl.barcodeScanned(null, { decodedText: barcode._data });
			  });
			}
		  };
		  $ctrl.scanditBarcodeCapture.addListener($ctrl.scanditListener);
		  $ctrl.scanditOverlay = await SDCBarcode.BarcodeCaptureOverlay.withBarcodeCaptureForView($ctrl.scanditBarcodeCapture, $ctrl.scanditView);    
		  $ctrl.scanditViewfinder = new SDCCore.RectangularViewfinder(
			SDCCore.RectangularViewfinderStyle.Square,
			SDCCore.RectangularViewfinderLineStyle.Light
		  );
		  await $ctrl.scanditOverlay.setViewfinder($ctrl.scanditViewfinder);
	  
		  $ctrl.scanditCameraSettings = SDCBarcode.BarcodeCapture.recommendedCameraSettings;
	  
		  // Depending on the use case further camera settings adjustments can be made here.
		  
		  $ctrl.scanditCamera = SDCCore.Camera.atPosition(SDCCore.CameraPosition.WorldFacing);
	
		  if ($ctrl.scanditCamera) {
			await $ctrl.scanditCamera.applySettings($ctrl.scanditCameraSettings);
			await $ctrl.scanditContext.setFrameSource($ctrl.scanditCamera);
		  }
		$ctrl.startScanner();
	}
	
	async startScanner() {
		const $ctrl = this;
		$ctrl.autoAdd = true;
    $ctrl.prodQuery.criteria.upcOnly = true;
			await $ctrl.scanditCamera.switchToDesiredState(SDCCore.FrameSourceState.On);
	}
	async stopScanner() {
		const $ctrl = this;
			await $ctrl.scanditCamera.switchToDesiredState(SDCCore.FrameSourceState.Off);
			$ctrl.scanMode = false;
	}
	barcodeScanned(e, args) {
	const $ctrl = this;
		if (args.decodedText) {
			$ctrl.scannedData = args.decodedText;
			$ctrl.lastResult = $ctrl.scannedData;
			$ctrl.getProduct($ctrl.scannedData);
			//$ctrl.stopScanner();
		}
	}
		  
}
